import { WithdrawalsOverviewClient } from "../../../../../../../../Wrap/Api/Payments/WithdrawalsOverview";
import { WithdrawalOverviewModel } from "../../../../../../../../Wrap/Models/Models/Payments/Withdrawals/WithdrawalOverviewModel";

export class ProductOverviewWithdrawalAction {
    public static getWithdrawalDetails(hierarchyId: string, callback: (data: WithdrawalOverviewModel) => void) {
        const client = new WithdrawalsOverviewClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }
}
